import {success} from "./helpers";
import {
	GET_CLIENT_SUBSCRIPTION_STATS, GET_CLIENT_STATS, GET_CLIENT_TAG_STATS, 
	GET_INSIGHTS_PERIOD_STATS, CLEAR_DASHBOARD_STATS
} from "../actions/Dashboard"

const initializeState = {
	client_subscription_stats: undefined,
	client_stats: undefined,
	client_tag_stats: undefined,
	insights_stats: undefined
}
export const dashboard = (state= initializeState, action) => {
	switch (action.type) {
		case success(GET_CLIENT_SUBSCRIPTION_STATS):
			return {
				...state,
				client_subscription_stats: action.payload
			}
		case success(GET_CLIENT_STATS):
			return {
				...state,
				client_stats: action.payload
			}
		case success(GET_CLIENT_TAG_STATS):
			return {
				...state,
				client_tag_stats: action.payload
			}
		case success(GET_INSIGHTS_PERIOD_STATS):
			return {
				...state,
				insights_stats: action.payload
			}
		case CLEAR_DASHBOARD_STATS:
			return {
				...initializeState
			}
		default:
			return state
	}
}

export default {
  dashboard
}


// WEBPACK FOOTER //
// ./src/reducers/dashboard.js